import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router);


/* 后台页面 路由配置 */
// 标签名
const realTagName = '智呈数据分析可视化平台';

// 数据处理
let source = [
    {
        path: 'dataSource',
        name: 'dataSource',
        meta: {
            title: ['数据处理', '数据接入'],
            tagName: realTagName,
            keepAlive: true
        },
        component: () => import('@/views/rearAllMain/dataUpload/dataSource/dataSource'),
    },
    {
        path: 'dataSet',
        name: 'dataSet',
        meta: {
            title: ['数据处理', '数据准备'],
            tagName: realTagName,
            keepAlive: true
        },
        component: () => import('@/views/rearAllMain/dataUpload/dataSet/dataSet'),
    },
    {
        path: 'viewSet',
        name: 'viewSet',
        meta: {
            title: ['数据处理', '多维分析'],
            tagName: realTagName,
            keepAlive: true
        },
        component: () => import('@/views/rearAllMain/dataUpload/viewSet/viewSet'),
    },
    {
        path: 'OData',
        name: 'OData',
        meta: {
            title: ['数据处理', '原生分析'],
            tagName: realTagName,
            keepAlive: true
        },
        component: () => import('@/views/rearAllMain/dataUpload/viewSet/OData'),
    },
    {
        path: 'createViewDP',
        name: 'createViewDP',
        meta: {
            title: ['数据处理', {name: '多维分析', path: '/viewSet'},'新增图表'],
            tagName: realTagName,
            keepAlive: true
        },
        component: () => import('@/views/rearAllMain/dataUpload/viewSet/createViewDP'),
    },
    {
        path: 'createViewDP2',
        name: 'createViewDP2',
        meta: {
            title: ['数据处理', {name: '原生分析', path: '/viewSet'},'新增图表'],
            tagName: realTagName,
            keepAlive: true
        },
        component: () => import('@/views/rearAllMain/dataUpload/viewSet/createViewDP2'),
    },
];

//综合展现
let screen = [
    {
        path: 'stencilList',
        name: 'stencilList',
        meta: {
            title: ['综合展现', '模版列表'],
            tagName: realTagName,
            keepAlive: true
        },
        component: () => import('@/views/rearAllMain/createScreen/view/stencil/stencilList'),
    },
    {
        path: 'addStencil',
        name: 'addStencil',
        meta: {
            title: ['综合展现', {name: '模版列表', path: '/stencilList'}, '新增模版'],
            tagName: realTagName,
            keepAlive: true
        },
        component: () => import('@/views/rearAllMain/createScreen/view/stencil/addStencil'),
    },
    {
        path: 'viewScreen',
        name: 'viewScreen',
        meta: {
            title: ['综合展现', {name: '模版列表', path: '/stencilList'}, '大屏预览'],
            tagName: realTagName,
            keepAlive: true
        },
        component: () => import('@/views/rearAllMain/createScreen/view/screen/viewScreen'),
    },
    {
        path: 'configScreen',
        name: 'configScreen',
        meta: {
            title: ['综合展现', {name: '模版列表', path: '/stencilList'}, {name: '大屏预览', path: '/viewScreen'}, '大屏配置'],
            tagName: realTagName,
            keepAlive: true
        },
        component: () => import('@/views/rearAllMain/createScreen/view/screen/configScreen'),
    }
];

//中心管控
let story = [
    {
        path: 'teamSharing',
        name: 'teamSharing',
        meta: {
            title: ['中心管控','共享列表'],
            tagName: realTagName,
            keepAlive: true
        },
        component: () => import('@/views/rearAllMain/teamSharing/teamSharing'),
    },
    {
        path: 'setContents',
        name: 'setContents',
        meta: {
            title: ['中心管控', {name: '共享列表', path: '/teamSharing'}, '内容设置'],
            tagName: realTagName,
            keepAlive: true
        },
        component: () => import('@/views/rearAllMain/teamSharing/setContents'),
    },
];

//运维管理
let OM = [
    {
        path: 'findUser',
        name: 'findUser',
        meta: {
            title: ['运维管理', '查找用户'],
            tagName: realTagName,
            keepAlive: true
        },
        component: () => import('@/views/rearAllMain/OMConfig/findUser/findUser'),
    },
    {
        path: 'userList',
        name: 'userList',
        meta: {
            title: ['运维管理', '用户列表管理'],
            tagName: realTagName,
            keepAlive: true
        },
        component: () => import('@/views/rearAllMain/OMConfig/userList/userList'),
    },
];
//中心管控2
let share = [
    {
        path: 'share',
        name: 'share',
        meta: {
            title: ['团队分享', '权限分配'],
            tagName: realTagName,
            keepAlive: true
        },
        component: () => import('@/views/rearAllMain/share/share'),
    },
];
//模型生成
let model = [
    {
        path: 'model',
        name: 'model',
        meta: {
            // title: ['模型处理'],
            tagName: realTagName,
            keepAlive: true
        },
        component: () => import('@/views/rearAllMain/model/model'),
    },
];

let report = [
    {
        path: 'report',
        name: 'report',
        meta: {
            tagName: realTagName,
            keepAlive: true
        },
        component: () => import('@/views/rearAllMain/report/report'),
    },
];

//登录注册
let LR = [
    {
        path: '/login',
        name: 'login',
        meta: {
            title: '登录',
            tagName: realTagName,
            keepAlive: true
        },
        component: () => import('@/views/login/login'),
    },
];


// 整体路由
let allRouteList = [
    {
        path: '/',
        redirect: '/login',
    },
    {
        path: '*',
        redirect: '/404',
    },
    {
        path: '/404',
        meta: {
            tagName: '404',
        },
        component: () => import('@/views/other/404'),
    },
    {
        path: '/preview',
        meta: {
            tagName: '',
        },
        component: () => import('@/views/rearAllMain/createScreen/view/preview/preview'),
    },
    {
        path: '/fullScreen/:id/:type',
        name:'fullScreen',
        meta: {
            tagName: '大屏预览页面',
        },
        component: () => import('@/views/rearAllMain/createScreen/view/preview/fullScreen'),
    },
    {
        path: '/shareScreen/:id',
        name:'shareScreen',
        meta: {
            tagName: '大屏分享页面',
        },
        component: () => import('@/views/rearAllMain/createScreen/view/preview/shareScreen'),
    },
    {
        path: '/contact',
        name: 'contact',
        meta: {
            title: '联系我们',
            tagName: realTagName,
        },
        component: () => import('@/views/rearAllMain/contact/contact'),
    },
    {
        path: '/upVip',
        name: 'upVip',
        meta: {
            title: '升级账号',
            tagName: realTagName,
        },
        component: () => import('@/views/rearAllMain/upVip/upVip'),
    },
    {
        path: '',
        name: 'rearMain',
        alias: '/rearMain',
        redirect: '/dataSource',
        meta: {
            tagName: realTagName,
        },
        component: () => import('@/views/rearAllMain/rearMain'),
        children: [...source, ...screen, ...story, ...OM, ...share,...model,...report]
    },
    ...LR,
];

export default new Router({
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0}
    },
    // mode: 'history',
    routes: [...allRouteList]
})